import { z } from "zod";
import { FieldProps } from "react-final-form";
import { FormSubmitCallback, FormBase, FormBaseProps, InputField, SelectField, SelectOption, MultiSelectField } from "ui";

import { useEffect, useState } from "react";

export const STAFF_FORM_FIELDS: FieldProps<string, any>[] = [
    {
        name: "firstName",
        label: "First Name",
        component: InputField,
        required: true,
        fullWidth: true,
        grid: {
            xs: 6,
        },
    },
    {
        name: "middleName",
        label: "Middle Name",
        component: InputField,
        required: false,
        fullWidth: true,
        grid: {
            xs: 6,
        },
    },
    {
        name: "lastName",
        label: "Last Name",
        component: InputField,
        required: true,
        fullWidth: true,
        grid: {
            xs: 6,
        },
    },
    {
        name: "roleType",
        label: "User Role / Type",
        component: SelectField,
        required: true,
        fullWidth: true,
        grid: {
            xs: 6,
        }
    },
    {
        name: "jobTitle",
        label: "Job Title",
        component: InputField,
        required: false,
        fullWidth: true,
        grid: {
            xs: 6,
        },
    },
    {
        name: "email",
        label: "Email",
        component: InputField,
        required: true,
        fullWidth: true,
        grid: {
            xs: 12,
        },
    },
];
export const ADD_STAFF_FORM_FIELDS: FieldProps<string, any>[] = [
    ...STAFF_FORM_FIELDS,
    {
        name: "location",
        label: "Location",
        component: MultiSelectField,
        required: true,
        fullWidth: true,
        grid: {
            xs: 12,
        }
    }
]
const roleTypeSchema = z.union([z.literal("ADMIN"), z.literal("STANDARD"), z.literal("OFFICE_ADMIN"), z.literal("SUPER_ADMIN"), z.null(), z.undefined()]);

export const performValidationSchema = z.object({
    firstName: z.string().trim().nonempty().max(255),
    middleName: z.string().trim().max(255).nullish(),
    lastName: z.string().trim().nonempty().max(255),
    jobTitle: z.string().trim().max(255).nullish(),
    email: z.string().nonempty().email(),
    roleType: roleTypeSchema.default("STANDARD"),
    // startDate: z.coerce.date()
});
export const addPerformValidationSchema = performValidationSchema.extend({
    location: z.array(
        z.string().trim().nonempty()
    ).min(1, "Please provide at least one location"),
});
export type StaffFormSchema = z.infer<typeof performValidationSchema>;
export type AddStaffFormSchema = z.infer<typeof addPerformValidationSchema>;
type FormState = {
    fields: FieldProps<string, any>[]
}

export type StaffFormProps = {
    roles: SelectOption[],
    locations?: SelectOption[]
    rolesLoading: boolean,
    initialValues: StaffFormSchema | null | undefined,
    onSubmit: (values: StaffFormSchema) => Promise<ReturnType<FormSubmitCallback>>
    onCancel: () => void
} & Pick<FormBaseProps<StaffFormSchema>, "initialValues" | "readonly">

export default function StaffForm({ roles, rolesLoading = true, initialValues, readonly, onSubmit, onCancel }: StaffFormProps) {

    const [formState, setFormState] = useState<FormState>({
        fields: STAFF_FORM_FIELDS
    });

    useEffect(() => {
        const fields = STAFF_FORM_FIELDS.map((field) => {
            if (field.name !== "roleType") return field;
            return {
                ...field,
                loading: rolesLoading,
                options: roles.map((role) => ({
                    label: role.label,
                    value: role.value,
                    isDefault: role.isDefault,
                })),
            }
        });

        setFormState(prevState => ({
            ...prevState,
            fields
        }))
    }, [roles]);
    console.log("i am pinging the right thing ye")
    useEffect(() => {
        console.log("the form fields:", formState)
    }, [formState])
    const StaffForm = FormBase<StaffFormSchema>({
        fields: formState.fields,
        initialValues: initialValues ?? {
            firstName: "",
            middleName: null,
            lastName: "",
            jobTitle: null,
            email: "",
            roleType: "STANDARD",
            location: [], // 👈 REQUIRED
        },
        validationSchema: performValidationSchema,
        buttonSubmitLabel: "Save",
        buttonCancelLabel: "Cancel",
        readonly,
        onSubmit: onSubmit,
        onCancel: onCancel
    })

    return StaffForm;
}